import { signUpType } from "api/types/signUpType"
import axios from "axios"
export const login = async (data: signUpType) => {

    return await axios.post(`${process.env.REACT_APP_API_URL}/v1/auth/login`, data)


}

 